const Home = () => {
    return <h1>Home Page</h1>;
  };
  
  export default Home;